/* Only a visible success response after submitting form 162624 starts this flow.
 * The purchase template is shared with the existing password-protected page.
 * No password or access code is needed or carried to the new page.
 */
(() => {
  'use strict';
  if (!/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?pages\/fitting-event\/?$/i.test(window.location.pathname)) return;
  const rootSelector = '.globo-form-id-162624';
  let submitted = false;
  let started = false;
  document.addEventListener('submit', event => {
    if (event.target instanceof Element && event.target.closest(rootSelector)) submitted = true;
  }, true);
  document.addEventListener('click', event => {
    if (event.target instanceof Element && event.target.closest(rootSelector + ' button[type="submit"]')) submitted = true;
  }, true);
  function check() {
    if (!submitted || started) return;
    const messages = document.querySelectorAll(rootSelector + ' .message.success');
    for (const message of messages) {
      if (!message.getClientRects().length || getComputedStyle(message).visibility === 'hidden') continue;
      const link = message.querySelector('a[href]');
      if (!link) continue;
      let configured;
      try { configured = new URL(link.getAttribute('href'), window.location.origin); } catch { continue; }
      if (configured.origin !== window.location.origin || !/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?pages\/(?:pathone-secret|pathone-event-purchase)\/?$/i.test(configured.pathname)) continue;
      const target = new URL(window.location.pathname.replace(/fitting-event\/?$/, 'pathone-event-purchase'), window.location.origin);
      const current = new URL(window.location.href);
      for (const source of [configured, current]) {
        source.searchParams.forEach((value, name) => {
          if (name.startsWith('utm_') || ['preview_theme_id', '_fd', 'pb'].includes(name)) target.searchParams.set(name, value);
        });
      }
      started = true;
      const form = message.closest('form');
      if (form) {
        form.classList.add('fitting-event-complete');
        form.querySelectorAll('.header, .wizard__header, .panels, .gfb__page-footer, .message.error, .message.success .dismiss').forEach(element => {
          element.hidden = true;
          element.style.setProperty('display', 'none', 'important');
        });
      }
      const notice = document.createElement('p');
      notice.textContent = '3秒後に先行販売ページへ移動します。';
      notice.setAttribute('role', 'status');
      message.appendChild(notice);
      link.href = target.href;
      link.textContent = '今すぐ先行販売ページへ進む';
      link.removeAttribute('target');
      link.classList.add('fitting-event-redirect__button');
      message.setAttribute('tabindex', '-1');
      message.focus({ preventScroll: true });
      const timer = window.setTimeout(() => window.location.assign(target.href), 3000);
      link.addEventListener('click', () => window.clearTimeout(timer), { once: true });
      observer.disconnect();
      break;
    }
  }
  const observer = new MutationObserver(check);
  observer.observe(document.documentElement, {subtree:true, childList:true, attributes:true, attributeFilter:['class','style','hidden']});
})();
